// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=color]::-webkit-color-swatch{border:none;border-radius:50%;padding:0}input[type=color]::-webkit-color-swatch-wrapper{border:none;border-radius:50%;padding:0}", ""]);
// Exports
module.exports = exports;
